'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadDeviceError = exports.submitUserInformation = exports.loadDeviceSetup = exports.LOAD_DEVICE_ERROR = exports.LOAD_DEVICE_SETUP = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doLoadDeviceSetup = doLoadDeviceSetup;
exports.doSubmitUserInformation = doSubmitUserInformation;
exports.watchLoadDeviceSetup = watchLoadDeviceSetup;

var _sagaTools = require('@classpass/saga-tools');

var _reduxFormSaga = require('redux-form-saga');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _helpers = require('redux/saga/helpers');

var _video = require('redux/modules/video');

var _bluetooth = require('constants/bluetooth');

var _bluetooth2 = _interopRequireDefault(_bluetooth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadDeviceSetup),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doSubmitUserInformation),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchLoadDeviceSetup);

var LOAD_DEVICE_SETUP = exports.LOAD_DEVICE_SETUP = 'LOAD_DEVICE_SETUP';
var LOAD_DEVICE_ERROR = exports.LOAD_DEVICE_ERROR = 'LOAD_DEVICE_ERROR';

var loadDeviceSetup = exports.loadDeviceSetup = function loadDeviceSetup() {
  return { type: LOAD_DEVICE_SETUP };
};
var submitUserInformation = exports.submitUserInformation = (0, _reduxFormSaga.createFormAction)('updateLiveProfile');
var loadDeviceError = exports.loadDeviceError = _helpers.errorActionCreator.bind(null, LOAD_DEVICE_ERROR);

function doLoadDeviceSetup(client) {
  return _regenerator2.default.wrap(function doLoadDeviceSetup$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          _context.next = 9;
          break;

        case 5:
          _context.prev = 5;
          _context.t0 = _context['catch'](0);
          _context.next = 9;
          return (0, _effects.put)(loadDeviceError(_context.t0));

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 5]]);
}

function doSubmitUserInformation(client, _ref) {
  var _ref$payload = _ref.payload,
      gender = _ref$payload.gender,
      birthDateMonth = _ref$payload.birthDateMonth,
      birthDateDay = _ref$payload.birthDateDay,
      birthDateYear = _ref$payload.birthDateYear,
      weight = _ref$payload.weight,
      tagline = _ref$payload.tagline;
  var data, nextStatus, dateOfBirth;
  return _regenerator2.default.wrap(function doSubmitUserInformation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          data = void 0;
          nextStatus = void 0;


          if (typeof tagline !== 'undefined') {
            nextStatus = _bluetooth2.default.PREPARE_WEARABLE;
            data = { tagline: tagline };
          } else {
            nextStatus = _bluetooth2.default.INPUT_TAGLINE;
            dateOfBirth = birthDateYear + '-' + String(birthDateMonth).padStart(2, '0') + '-' + String(birthDateDay).padStart(2, '0');

            data = {
              gender: gender,
              date_of_birth: dateOfBirth,
              weight: {
                lb: parseFloat(weight)
              }
            };
          }

          _context2.next = 6;
          return (0, _effects.call)(client.users.updateUserProfile, data);

        case 6:
          _context2.next = 8;
          return (0, _effects.all)([(0, _effects.put)(submitUserInformation.success()), (0, _effects.put)((0, _video.updateDevice)({ status: nextStatus }))]);

        case 8:
          _context2.next = 10;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.userProfile, [client]);

        case 10:
          _context2.next = 16;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 16;
          return (0, _effects.put)(loadDeviceError(_context2.t0));

        case 16:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 12]]);
}

function watchLoadDeviceSetup(client) {
  return _regenerator2.default.wrap(function watchLoadDeviceSetup$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_DEVICE_SETUP, doLoadDeviceSetup, client);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, submitUserInformation.REQUEST, doSubmitUserInformation, client);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}